/**
 * @module app.core
 */

import { I18N } from 'aurelia-i18n';
import { autoinject } from 'aurelia-framework';
import { IModelMetadata } from 'app/core/models/model-metadata';
import { signalNames } from 'app/shared/lib/signals';

@autoinject()
export class StampValueConverter {

    public signals: string[] = [signalNames.timeZoneChanged, signalNames.languageChanged];

    constructor(private readonly i18n: I18N) { }

    /**
     * Gets a localized human-readable version of a model metadata stamp.
     *
     * @param value `Core.StandardModelMetadata`
     * @param type one of the metadata properties, such as `created` *(default)*, `modified`, or `activeChanged`
     */
    public toView(value: unknown, type?: string, whatKey?: string): string | null {
        if(value === null || value === undefined || typeof value !== 'object') { return null; }

        const stampType = type || 'created';
        const metadata = value as IModelMetadata;
        const stamp = metadata[stampType];
        const what = !!whatKey ? this.i18n.tr(whatKey) : null;

        if(!stamp) { return null; }

        if(stamp.timestamp) {
            const user: string = stamp.byUser && stamp.byUser.name && stamp.byUser.name.full || '';
            const key = `ui:stamps.${stampType}.timestamp`;
            return this.i18n.tr(key, { timestamp: stamp.timestamp, user: user, what: what });
        }
        else if(stamp.dateTime) {
            const user: string = stamp.byUser && stamp.byUser.name && stamp.byUser.name.full || '';
            const key = `ui:stamps.${stampType}.dateTime`;
            return this.i18n.tr(key, { timestamp: stamp.timestamp, user: user, what: what });
        }
        else if(stamp.date) {
            const user: string = stamp.byUser && stamp.byUser.name && stamp.byUser.name.full || '';
            const key = `ui:stamps.${stampType}.date`;
            return this.i18n.tr(key, { date: stamp.timestamp, user: user, what: what });
        }

        return null;
    }

}
